/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CourtHearingCourtResponse
 */
export interface CourtHearingCourtResponse {
    /**
     * 
     * @type {string}
     * @memberof CourtHearingCourtResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CourtHearingCourtResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CourtHearingCourtResponse
     */
    shortCode: string;
}

/**
 * Check if a given object implements the CourtHearingCourtResponse interface.
 */
export function instanceOfCourtHearingCourtResponse(value: object): value is CourtHearingCourtResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('shortCode' in value) || value['shortCode'] === undefined) return false;
    return true;
}

export function CourtHearingCourtResponseFromJSON(json: any): CourtHearingCourtResponse {
    return CourtHearingCourtResponseFromJSONTyped(json, false);
}

export function CourtHearingCourtResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourtHearingCourtResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'shortCode': json['shortCode'],
    };
}

export function CourtHearingCourtResponseToJSON(json: any): CourtHearingCourtResponse {
    return CourtHearingCourtResponseToJSONTyped(json, false);
}

export function CourtHearingCourtResponseToJSONTyped(value?: CourtHearingCourtResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'shortCode': value['shortCode'],
    };
}

